module.exports = __webpack_public_path__ + "static/media/Avatars_Female-27.6d9860a9.png";